import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';

import { FirestoreCollections, firestore } from '../../../firebase.config';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import Scenario from '../../models/Scenario';

async function deleteScenario(
  scenario: Scenario,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new DeleteScenarioFailure('Unauthorized', 'unauthorized');
  }
  try {
    const db = firestore;
    const numberId = scenario.id;
    const contactsCollectionRef = collection(db, FirestoreCollections.contacts);
    const subsCollectionRef = collection(db, FirestoreCollections.subscriptions);

    const contactsSnapshot = await getDocs(query(
      contactsCollectionRef,
      where('contact.prospect_category', '==', numberId)
    ));

    const subsSnapshot = await getDocs(query(
      subsCollectionRef,
      where('id_scenarios', 'array-contains', numberId)
    ));

    if (contactsSnapshot.empty && subsSnapshot.empty) {
      await deleteDoc(doc(firestore, FirestoreCollections.scenarios, numberId));
    } else {
      throw new DeleteScenarioFailure('Ce scenario est déja utilisé par un contact / actif sur un abonnement');
    }

    return;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof DeleteScenarioFailure) {
      throw new DeleteScenarioFailure(e.message);
    } else {
      throw new DeleteScenarioFailure('Erreur lors de la suppression du scénario');
    }
  }
}

export class DeleteScenarioFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteScenario;
